export default __webpack_public_path__ + "static/media/peanut.9db4a612.svg";